/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantMessage
 */
export interface AssistantMessage {
    /**
     * 
     * @type {string}
     * @memberof AssistantMessage
     */
    role: AssistantMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AssistantMessage
     */
    content: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssistantMessage
     */
    annotations?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AssistantMessage
     */
    date?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssistantMessage
     */
    context?: boolean;
}


/**
 * @export
 */
export const AssistantMessageRoleEnum = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant'
} as const;
export type AssistantMessageRoleEnum = typeof AssistantMessageRoleEnum[keyof typeof AssistantMessageRoleEnum];


/**
 * Check if a given object implements the AssistantMessage interface.
 */
export function instanceOfAssistantMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function AssistantMessageFromJSON(json: any): AssistantMessage {
    return AssistantMessageFromJSONTyped(json, false);
}

export function AssistantMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': json['role'],
        'content': json['content'],
        'annotations': !exists(json, 'annotations') ? undefined : json['annotations'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'context': !exists(json, 'context') ? undefined : json['context'],
    };
}

export function AssistantMessageToJSON(value?: AssistantMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
        'content': value.content,
        'annotations': value.annotations,
        'date': value.date,
        'context': value.context,
    };
}

